import { Box, Typography } from '@mui/material';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi, DialogUI } from '../../../Interface';
import { dataGridPremiumColumns } from '../../../../utils/helper';
import dayjs from 'dayjs';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import fpProdgeneratorService from '../../../../service/client/folplast/fpProdgenerator.service';

const DetailDialog = ({ open, handleClose, data }) => {
  const warehouseApiRef = useGridApiRef();

  const prodCol = () => {
    return dataGridPremiumColumns([
      {
        field: 'workingNumber',
        headerName: 'Gyártási utasítás száma',
        type: 'string',
      },
      {
        field: 'articleNumber',
        headerName: 'Cikkszám',
        type: 'string',
      },
      {
        field: 'articleName',
        headerName: 'Cikknév',
        type: 'string',
      },
      {
        field: 'productionQuantity',
        headerName: 'Tervezett mennyiség',
        type: 'number',
      },
    ]);
  };

  const fromWarehouseCol = () => {
    return dataGridPremiumColumns([
      {
        field: 'itemCode',
        headerName: 'Cikkszám',
        type: 'string',
      },
      {
        field: 'itemName',
        headerName: 'Cikknév',
        type: 'string',
        valueGetter: (_params, row) => {
          return row.item.itemName;
        },
      },
      {
        field: 'qty',
        headerName: 'Mennyiség',
        type: 'number',
      },
      {
        field: 'status',
        headerName: 'Státusz',
        type: 'string',
      },
      {
        field: 'createdAt',
        headerName: 'Létrehozás dátuma',
        type: 'dateTime',
        valueGetter: (value) => new Date(value),
        valueFormatter: (value) => dayjs(value).format('YYYY.MM.DD. HH:mm'),
      },
      {
        field: 'createdBy',
        headerName: 'Létrehozó felhasználó',
        type: 'string',
        valueGetter: (_params, row) => {
          return row.user.nickName;
        },
      },
      {
        field: 'deleteRow',
        headerName: '',
        type: 'actions',
        renderCell: (params) => {
          return (
            <ButtonUI text="Visszavonás" className="bg-warning" onClick={() => handleDeleteWarehouse(params.row.id)} />
          );
        },
      },
    ]);
  };

  const handleDeleteWarehouse = (id) => {
    fpProdgeneratorService.deleteFromWarhouse(id).then(() => {
      warehouseApiRef.current.updateRows([{ id, _action: 'delete' }]);
    });
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Részletek"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '850px',
          },
        },
      }}
    >
      <Box>
        <Typography mt="1rem">Generált gyártási utasítások</Typography>
        <DatagridPremiumUi
          datagridIdentifier={DataGridIdentifiers.DetailProdTable}
          datagridInitialState={{ density: 'compact' }}
          height={300}
          rows={data.production}
          hideFooter
          columns={prodCol()}
          paginationAndfilterMode="client"
        />
        <Typography mt="1rem">Raktárról</Typography>
        <DatagridPremiumUi
          apiRef={warehouseApiRef}
          datagridIdentifier={DataGridIdentifiers.DetailFromWarehouseTable}
          datagridInitialState={{ density: 'compact' }}
          height={300}
          rows={data.fromWarehouse}
          hideFooter
          columns={fromWarehouseCol()}
          paginationAndfilterMode="client"
        />
      </Box>
    </DialogUI>
  );
};

export default DetailDialog;
